import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

export function DeeplinkRouter() {
  const location = useLocation();
  const newLocation = `${location.pathname.replace('/deeplink', '')}${location.search && location.search}`;
  return <Redirect to={newLocation} />;
}
